import React, { useState } from "react"
import { Link } from "react-router-dom"
import { API } from "../config/api"
import { THEME } from "../config/theme"

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState("")
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const resp = await fetch(`${API.baseUrl}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })
      if (!resp.ok) {
        throw new Error("Request failed")
      }
      setSuccess(true)
    } catch {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const inputStyle: React.CSSProperties = {
    width: "100%",
    height: "44px",
    border: `0.5px solid ${THEME.colors.neutral.light.border}`,
    borderRadius: THEME.borderRadius.md,
    padding: "0 12px",
    fontSize: "15px",
    fontFamily: THEME.fonts.primary,
    boxSizing: "border-box",
    marginBottom: "16px",
    outline: "none",
  }

  const labelStyle: React.CSSProperties = {
    display: "block",
    fontSize: "13px",
    fontWeight: 600,
    color: THEME.colors.neutral.light.textPrimary,
    marginBottom: "6px",
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: THEME.colors.brandGradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: THEME.fonts.primary,
      }}
    >
      <div
        style={{
          width: "400px",
          background: THEME.colors.neutral.light.surface,
          border: `0.5px solid ${THEME.colors.neutral.light.border}`,
          borderRadius: THEME.borderRadius.lg,
          padding: "40px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: 600,
            color: THEME.colors.neutral.light.textPrimary,
            textAlign: "center",
            marginBottom: "8px",
          }}
        >
          Forgot password
        </div>
        <div
          style={{
            fontSize: "14px",
            color: THEME.colors.neutral.light.textSecondary,
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          Enter your email and we'll send you a reset link.
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email" style={labelStyle}>Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
            autoComplete="email"
            required
          />

          <button
            type="submit"
            disabled={loading || success}
            style={{
              width: "100%",
              height: "44px",
              background: THEME.colors.navy,
              color: THEME.colors.white,
              fontWeight: 500,
              fontSize: "14px",
              border: "none",
              borderRadius: THEME.borderRadius.md,
              marginTop: "8px",
              cursor: loading || success ? "not-allowed" : "pointer",
              opacity: loading || success ? 0.7 : 1,
              fontFamily: THEME.fonts.primary,
            }}
          >
            {loading ? "Sending..." : "Send reset link"}
          </button>

          {success && (
            <div
              style={{
                background: "rgba(5, 150, 105, 0.08)",
                color: THEME.colors.semantic.success,
                border: "0.5px solid rgba(5, 150, 105, 0.3)",
                padding: "10px 12px",
                borderRadius: THEME.borderRadius.md,
                marginTop: "12px",
                fontSize: "13px",
                textAlign: "center",
              }}
            >
              Check your email for a reset link.
            </div>
          )}

          {error && !success && (
            <div
              style={{
                background: "rgba(220, 38, 38, 0.08)",
                color: THEME.colors.semantic.danger,
                border: "0.5px solid rgba(220, 38, 38, 0.3)",
                padding: "10px 12px",
                borderRadius: THEME.borderRadius.md,
                marginTop: "12px",
                fontSize: "13px",
              }}
            >
              {error}
            </div>
          )}

          <div style={{ textAlign: "center", marginTop: "16px" }}>
            <Link
              to="/login"
              style={{
                fontSize: "13px",
                color: THEME.colors.navy,
                textDecoration: "none",
              }}
            >
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
